import { render, staticRenderFns } from "./AndroidInstallInstructions.vue?vue&type=template&id=1a6ff847&scoped=true&"
import script from "./AndroidInstallInstructions.vue?vue&type=script&lang=js&"
export * from "./AndroidInstallInstructions.vue?vue&type=script&lang=js&"
import style0 from "./AndroidInstallInstructions.vue?vue&type=style&index=0&id=1a6ff847&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6ff847",
  null
  
)

export default component.exports